import { expedientEntityId } from "@/general/entityIds"
import { FileInfo } from "../components/uploaderComponent/UploaderTypes"

interface ResponseUseDuplicate {
  isDuplicateFile: (currentState: any, newFiles: string[]) => boolean
  checkDuplicates: (currentState: any, files: FileInfo[]) => FileInfo[]
}

export const EXPEDIENT_ID_TYPE = expedientEntityId.toString()
export const VIEW_ALL_OPTION = "ver todos"

export default function useDuplicate(): ResponseUseDuplicate {

  const isDuplicateFile = (currentState: any, newFiles: string[]): boolean => {
    const files = currentState.files.map((f: File) => f.name)
    return newFiles.some(newFile => files.includes(newFile))
  }

  const checkDuplicates = (currentState: any, files: FileInfo[]): FileInfo[] => {
    const viewAllFiles = currentState.cwd.basePath.includes(VIEW_ALL_OPTION)
    const duplicated = currentState.files.filter((existingFile: any) => files.some((file: any) => {
      if (viewAllFiles) {
        return file.name === existingFile.name && existingFile.idEntityType === EXPEDIENT_ID_TYPE
      }
      return file.name === existingFile.name && !file.parent
    }))
    return duplicated
  }

  return {
    checkDuplicates,
    isDuplicateFile
  }
}
